import { render, staticRenderFns } from "./signCustomer.vue?vue&type=template&id=59038554&"
import script from "./signCustomer.vue?vue&type=script&lang=js&"
export * from "./signCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports